// Apollo
import { apolloClient } from '@/graphql';
import gql from 'graphql-tag';

// GraphQL
import UpdateLocations from '@/graphql/locations/update/updateLocations.gql';
import InsertLocations from '@/graphql/locations/insert/insertLocations.gql';
import DeleteLocation from '@/graphql/locations/delete/deleteLocation.gql';
import UpdateLocationDetail from '@/graphql/locations/update/UpdateLocationDetail.gql';
import InsertAmenities from '@/graphql/amenities/insertAmenities.gql';
import DeleteAmenities from '@/graphql/amenities/deleteAmenities.gql';
import InsertBenefits from '@/graphql/benefits/insertBenefits.gql';
import DeleteBenefits from '@/graphql/benefits/deleteBenefits.gql';

export default {
	state: {
		locations: [] as Location[],
	},

	// ================ Getters ================
	getters: {
		locations(state: any) {
			return state.locations;
		},
	},

	// ================ Mutations ================
	mutations: {
		setLocations(state: any, locations: any) {
			state.locations = locations;
		},
	},

	// ================= Actions =================
	actions: {
		// =================================================
		// Update a Locations in Hasura
		// =================================================

		async updateLocationGeneral({ dispatch }: any, object: any) {
			const response: any = await apolloClient
				.mutate({
					mutation: gql`
						mutation updateLocationGeneral($id: uuid!, $object: locations_set_input!) {
							update_locations(where: { id: { _eq: $id } }, _set: $object) {
								affected_rows
							}
						}
					`,
					// Parameters
					variables: {
						id: object.id,
						object,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			return response.data;
		},

		async getLocations({ commit }: any) {
			const response = await apolloClient.query({
				query: gql`
					query Locations {
						locations {
							id
							name
							city_id
							incremental_time
							cityObj: city {
								id
								name
								countryObj: country {
									id
									name
								}
							}
							pitches {
								id
								name
								type
								location_id
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
			});

			const { locations } = response.data;
			console.log("locations locations",locations)
			commit('setLocations', locations);
		},

		async insertLocation({ dispatch }: any, payload: any) {
			console.log('insertLocation');
			console.log(payload);

			const objects = [
				{
					name: payload.name,
					pitch_name: payload.pitch_name,
					city_id: payload.cityId,
				},
			];

			const response = await apolloClient.mutate({
				mutation: InsertLocations,
				// Parameters
				variables: {
					objects,
				},
			});

			const { insert_locations } = response.data;

			const locationId = insert_locations.returning[0].id;

			const pitches = payload.pitches.map((p: any) => {
				return {
					name: p.name,
					type: p.type,
					pitch_name: p.pitch_name,
					locationId,
				};
			});

			dispatch('insertPitches', pitches);

			dispatch('getLocations');
			return;
		},

		async deleteLocation({ dispatch }: any, payload: any) {
			const { id } = payload;
			await apolloClient
				.mutate({
					mutation: DeleteLocation,
					// Parameters
					variables: {
						locationId: id,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			dispatch('getLocations');
			return;
		},

		async updateLocation({ dispatch }: any, payload: any) {
			const { id, name, cityId } = payload;

			// Update Location
			await apolloClient.mutate({
				mutation: UpdateLocations,
				variables: {
					locationId: id,
					name,
					cityId,
				},
			});

			// Update Pitches
			const pitches = payload.pitches.map((p: HasuraPitch) => {
				return {
					id: p.id,
					name: p.name,
					type: p.type,
				};
			});

			// pitches.map((p: HasuraPitch) => dispatch('updatePitch', p));

			await dispatch('getLocations');
			await dispatch('getPitches');
			return;
		},

		async updateLocationV2({ dispatch }: any, location: any) {
			// Update Location
			await apolloClient.mutate({
				mutation: UpdateLocations,
				variables: {
					locationId: location.id,
					name: location.name,
					cityId: location.city,
					logoUrl: location.logo_url,
					imageUrl: location.image_url,
					address: location.address,
					email: location.email,
					phone_number: location.phone_number,
					// field_size: location.field_size,
					longitude: location.longitude,
					latitude: location.latitude,
					vat: location.vat,
					about: location.about,
					extra_info: location.extra_info,
					extra_infoNL: location.extra_infoNL,
					aboutNL: location.aboutNL
				},
			});

			await dispatch('getLocations');
			await dispatch('getPitches');
			return;
		},
		async updateLocationDetails({ dispatch }: any, location: any) {
			// Update Location Details
			await apolloClient.mutate({
				mutation: UpdateLocationDetail,
				variables: {
					locationId: location.id,
					minimumDuration: location.minimumDuration,
					incrementalTime: location.incrementalTime,
					pwaPublish: location.pwaPublish,
					currency: location.currency,
					noticePeriod: location.noticePeriod,
				},
			});

			await dispatch('getLocations');
			await dispatch('getPitches');
			return;
		},

		async getVenueMatches({ commit }: any, venueId: string) {
			const response = await apolloClient.query({
				query: gql`
					query matchesByVenue($venueId: uuid!) {
						matches(where: { pitchByPitch: { location_id: { _eq: $venueId } } }) {
							id
							awayTeamObj: team {
								id
								name
							}
							homeTeamObj: teamByHomeTeam {
								id
								name
							}
							phHomeObj: placeholderTeamByPlaceholderHomeTeam {
								id
								name
							}
							phAwayObj: placeholder_team {
								id
								name
							}
							pitchByPitch {
								location {
									id
									name
									address
								}
							}
							away_score
							date
							game_length
							home_score
							is_friendly
							kick_off_time
							league
							slot_time
							postponed
							refereeByReferee {
								id
								first_name
								last_name
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
				variables: {
					venueId,
				},
			});

			const { matches } = response.data;
			return matches;
			// commit('setLocations', locations);
		},

		async insertAmenities({ dispatch }: any, objects: any) {
			await apolloClient
				.mutate({
					mutation: InsertAmenities,
					// Parameters
					variables: {
						objects,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			await dispatch('getLocations');
			return;
		},

		async deleteAmenities({ dispatch }: any, ids: string[]) {
			await apolloClient
				.mutate({
					mutation: DeleteAmenities,
					// Parameters
					variables: {
						amenityIds: ids,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			await dispatch('getLocations');
			return;
		},

		async insertBenefits({ dispatch }: any, objects: any) {
			await apolloClient
				.mutate({
					mutation: InsertBenefits,
					// Parameters
					variables: {
						objects,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			await dispatch('getLocations');
			return;
		},

		async deleteBenefits({ dispatch }: any, ids: string[]) {
			await apolloClient
				.mutate({
					mutation: DeleteBenefits,
					// Parameters
					variables: {
						benefitIds: ids,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			await dispatch('getLocations');
			return;
		},
	},
};
